import { transport } from 'config/transport';

export function callApiGetListOfChiNoiTru(congDoanId, month, year) {
    return transport.get(`/noitru/${congDoanId}/thuchi/chinoitru`, { params: { month, year } });
}
